import { Analytics } from 'Shared/utils/client';
import { Column, Icon, Row, Typography } from '@viewup/ui';
import { usageLists } from './ViewupUsage.const';

export const ViewupUsage = () => {
  return (
    <Column gap={16}>
      <Typography fontType='body.medium'>뷰업 한눈에 보기</Typography>
      <Row gap={8}>
        {usageLists.map((list) => (
          <Column
            bgColor='bg.secondary'
            br={16}
            css={{ cursor: 'pointer' }}
            flex={1}
            gap={4}
            key={list.title}
            onClick={() => {
              window.open(list.url, '_blank');
              Analytics.getInstance().track('MAIN_GUIDE', { type: list.type });
            }}
            p={12}
          >
            <Typography color='text.tertiary' fontType='caption.regular'>
              {list.title}
            </Typography>
            <Typography css={{ whiteSpace: 'pre-wrap' }} fontType='body2.medium'>
              {list.content}
            </Typography>
            <Row justifyContent='flex-end'>
              <Icon color='icon.point' size='XS' source={list.icon} />
            </Row>
          </Column>
        ))}
      </Row>
    </Column>
  );
};
